import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import { numeral } from '@fund/basic-lib/dist/lib/numeral';
import Model from 'ducker-model';

const property = {
  date: String,
  netValue: String, // 单位净值
  historyNetValue: String, // 累计净值
  netValueRise: String, // 单位净值涨幅
  navType: String, // 净值类型
  rise: String, // 净值涨幅
  currencyRise: String, // 货币涨幅
};

const replacedKeyFromPropertyName = {
  date: {
    property: 'FSRQ',
    computed: (date) => (isEmpty(date) ? '--' : date.replace(/(\d{4})-(\d{2})-(\d{2})/, '$2-$3')),
  },
  netValue: { // 单位净值
    property: 'DWJZ',
    defaultValue: '--',
    computed: (value) => (isEmpty(value) ? '--' : numeral(value).format('0.0000')),
  },
  historyNetValue: { // 累计净值
    property: 'LJJZ',
    defaultValue: '--',
    computed: (value) => (isEmpty(value) ? '--' : numeral(value).format('0.0000')),
  },
  netValueRise: { // 单位净值涨幅
    property: 'JZZZL',
    computed: (value) => (isEmpty(value) ? '--' : `${numeral(value).format('0.00')}%`),
  },
  navType: { // 净值类型
    property: 'NAVTYPE',
    computed: (value) => (isEmpty(value) ? '--' : parseInt(value, 10)),
  },
  rise: { // 净值涨幅
    property: 'JZZZL',
    computed: (value) => (isEmpty(value) ? '--' : `${numeral(value).format('0.00')}%`),
  },
  currencyRise: { // 货币涨幅
    property: 'LJJZ',
    computed: (value) => (isEmpty(value) ? '--' : `${numeral(value).format('0.0000')}%`),
  },
};

export default new Model(property, replacedKeyFromPropertyName);
